import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { AppShell } from '@/components/layouts/AppShell'

import { makeProfileQuery, makeReviewQuery } from './-queries';

export const Route = createFileRoute('/app/profile/employer/$employerId')({
  beforeLoad: ({ context }) => {
    if (!context.auth?.isAuthenticated) {
      throw redirect({ to: "/auth/login" });
    }
    if (context.auth.user?.role !== "worker") {
      // Redirect to the authenticated user's dashboard
      throw redirect({
        to: "/app/$role/dashboard",
        params: { role: context.auth.user?.role ?? 'worker'},
      });
    }
  },
  loader: ({ params, context }) => {
    context.queryClient.ensureQueryData(makeProfileQuery(params.employerId))
    context.queryClient.ensureQueryData(makeReviewQuery(params.employerId))
  },

  component: RouteComponent,
})

function RouteComponent() {
  return <AppShell><Outlet /></AppShell>
}

